import React from 'react';
import ReportingMembershipsUpcomingRenewalsPage from '../components/ReportingMembershipsUpcomingRenewalsPage';

const ReportingMembershipsUpcomingRenewalsApp = (props) => (
  <ReportingMembershipsUpcomingRenewalsPage {...props} />
);

export default ReportingMembershipsUpcomingRenewalsApp;
